/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useLocation } from 'react-router-dom';
import { ILanding, IToUp } from "src/modules/pe-landing-module/data/interfaces";
import { Position } from "@blueprintjs/core";
import { getLandingContainer } from "../../utils/getLandingContainer";
import addCSSClass from "src/libs/layout-app/utils/addCSSClass";
import { getCssDemention } from "src/libs/utilities";
import { NAVIGATION_DESIGN_TYPE } from "src/libs/useful/gallery/Gallery";
import { getSingleTypoStyle } from "../../utils/getTypographyStyle";
import { getSCCBorderStyle } from "../../utils/getBorderStyle";
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store";

export interface IToUpProps {
    
}
const ToUp = (props: IToUpProps): JSX.Element => {
    const currentLanding:ILanding   = useLandingStore((state: ILandingStore) => state.currentLanding)
    const isEdit                    = useLandingConsoleStore((state:ILandingConsoleStore) => state.isEdit)
    const data: IToUp = currentLanding.toUp 
    let location = useLocation(); 
    const usl = () =>
    {   
        return getLandingContainer()?.scrollTop > window.screen.height / 2
    }
    const _onScroll = () => {
        setVisible( usl() )
    }
    const [visible, setVisible] = useState( usl() )

    useEffect(() =>
    { 
        let top: string | number     = "auto"
        let bottom: string | number  = "auto"
        let left: string | number    = "auto"
        let right: string | number   = "auto"
        const position  = data.position || {}
        const width     = parseInt( (position.width || 40).toString() )
        const margin    = data.margin || 30  

        let _switch = (width || 70) + margin

        switch( data.place )
        {
            case Position.LEFT_TOP:
                top     = getCssDemention(position.top)
                bottom  = "auto"
                left    = getCssDemention(position.left)
                right   = "auto" 
                break
            case Position.RIGHT_TOP:            
                top     = getCssDemention(position.top)
                bottom  = "auto"
                left    = "auto"
                right   = getCssDemention(position.right)
                break
            case Position.TOP:                     
                top     = getCssDemention(position.top)
                bottom  = "auto"
                left    = "auto"
                right   = `calc(50% - ${ width / 2 }px)`
                break
            case Position.LEFT:                     
                top     = `calc(50% - ${ width / 2 - parseInt(position.top?.toString() || "0")}px)`
                bottom  = "auto" 
                left    = getCssDemention(position.left)
                right   = "auto" 
                break
            case Position.RIGHT:                   
                top     = `calc(50% - ${width / 2 - parseInt(position.top?.toString() || "0")}px)`
                bottom  = "auto" 
                left    = "auto"
                right   = getCssDemention(position.right)
                break
            case Position.LEFT_BOTTOM:
                top     = "auto"
                bottom  = getCssDemention(position.bottom )
                left    = getCssDemention(position.left)
                right   = "auto" 
                break
            case Position.BOTTOM:
                top     = "auto"
                bottom  = getCssDemention(position.bottom)
                left    = `calc(50% - ${ width / 2 }px)`
                right   = "auto"
                break
            case Position.RIGHT_BOTTOM:
            default:
                top     = "auto"
                bottom  = getCssDemention(position.bottom)
                left    = "auto"
                right   = getCssDemention(position.right)
                break
        }
        const translateX = 
            ([ Position.LEFT, Position.LEFT_BOTTOM, Position.LEFT_TOP ] as Position[]).includes( data.place ) 
                ? 
                -margin - (width || 70) 
                : 
                ([ Position.TOP, Position.BOTTOM ] as Position[]).includes( data.place ) 
                    ? 
                    -( 0 + (width || 70) ) / 2
                    : 
                    _switch
        const translateY = data.place === Position.TOP 
            ? 
            -margin - (width || 70) 
            : 
            data.place === Position.BOTTOM 
                ?
                parseInt( bottom ) + margin + (width || 70)  
                :
                0
        addCSSClass(
            `to-up`,
            `.to-up {
                top: ${top};
                bottom: ${bottom};
                left: ${left};
                right: ${right};
                margin: ${ margin }px;
                width: ${ (width || 70) }px;
                height:${ (width || 70) }px;
                ${ getSingleTypoStyle(data.font_size, "font_size") }
                ${ getSingleTypoStyle(data.text_color, "text_color") } 
                ${ getSCCBorderStyle( data.border ) }
                background-color:${ data.bg || "var(--force-plain-color)" };
                background-image:url(/assets/img/up-arrow.svg);
                user-select: none;
                cursor:pointer;
            }
            .show-to-top
            { 
                transform: translateX(${ ([ Position.TOP, Position.BOTTOM ] as Position[]).includes( data.place ) ? translateX : 0 }px) translateY(0px);
            }
            .hide-to-top
            { 
                transform: translateX(${ translateX }px) translateY(${ translateY }px);
            }`
        )
        const container = getLandingContainer()
        container.addEventListener( 'scroll', _onScroll ); 
        return () => container.removeEventListener( 'scroll', _onScroll ) 
    }, [])
    
    return <div
        className= { `to-up landing-portal ${ visible ? "show-to-top" : "hide-to-top" }`}
        onClick={
            () => {
                window.history.replaceState(undefined, "", `${location.pathname}`)
                getLandingContainer().scrollTo({
                    behavior: 'smooth',
                    top: 0,
                })
            }
        }
    >
        <i className={`fas fa-${data.design || NAVIGATION_DESIGN_TYPE.LONG_ARROW}-up`} />
    </div> 
}
export default ToUp